import { useTranslation } from '@translations';
import {
    getChildrenListDataAttrs,
    getDocumentConsentDataAttrs,
    getEnterApproverParentInformationDataAttrs,
} from './utils';

export const useDataAttributes = () => {
    const { processSummary, next, childCard, pendingProcess, smartspar } = useTranslation();

    return {
        documentConsentDataAttributes: {
            documentAvtaleOmAksjesparekonto: getDocumentConsentDataAttrs(
                'document-avtale-om-aksjesparekonto',
                processSummary.documentConsent.documentAvtaleOmAksjesparekonto,
            ),
            submitButton: getDocumentConsentDataAttrs('submit-document-consent', next),
        },
        childrenListDataAttributes: {
            giveConsent: getChildrenListDataAttrs('give-consent', childCard.giveConsent),
            completeKYCForm: getChildrenListDataAttrs('complete-kyc-form', childCard.completeKYCForm),
            createAsk: getChildrenListDataAttrs('create-ask-button', childCard.createAsk),
            goToStatus: getChildrenListDataAttrs('go-to-status', childCard.goToStatus),
            goToCompleteStatus: getChildrenListDataAttrs('go-to-complete-status', childCard.goToCompleteStatus),
            startSaving: getChildrenListDataAttrs('start-saving', smartspar.startSaving),
        },
        enterApproverParentInformationDataAttributes: {
            submitButton: getEnterApproverParentInformationDataAttrs('submit-approver-parent-phone', next),
        },
        pendingProcessDataAttributes: {
            aboutAskLink: getEnterApproverParentInformationDataAttrs(
                'about-ask-link',
                pendingProcess.details.aboutAskLinkText,
            ),
        },
    };
};
